/*
  OutputDialog.jsx
*/

// Npm.
import React, { useState, useEffect } from 'react';

// Components.
import Dialog from '../../Dialog';
import Tabs from '../../Tabs';
import SimulateSection from './SimulateSection';
import SubroutineSection from './SubroutineSection';
//import CostsSection from './CostsSection';
import ExportSection from './ExportSection';
import ImportSection from './ImportSection';
import AdvancedSection from './AdvancedSection';

// Hooks.
import useBotech from '../../../hooks/useBotech';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  tabsContainer: {
    marginBottom: theme.space(4),
  },
}));

/**
 * Dialog for handling IO.
 */
export default function OutputDialog({
  className,
  graphData,
  open = false,
  onClose,
  onChangeGraphData,
  ...rest
}) {

  const { saveModel } = useBotech();

  const subroutineCount = graphData._botech?.subroutines?.length || 0;

  const tabOptions = [
    {
      label: 'Simulate',
      value: 'simulate',
    },
    // {
    //   label: 'Resources',
    //   value: 'resources',
    // },
    {
      label: 'Subroutines' + (subroutineCount > 0 ? ` (${subroutineCount})` : ''),
      value: 'subroutines',
    },
    {
      label: (saveModel ? 'Save / ' : '') + 'Export',
      value: 'export',
    },
    {
      label: 'Import',
      value: 'import',
    },
    {
      label: 'Advanced',
      value: 'advanced',
    },
  ];

  const classes = useStyles();
  const [tab, setTab] = useState(tabOptions[0].value);

  // Handlers.

  function handleChangeTab(event, value) {
    setTab(value);
  }

  return (
    <Dialog
      className={className}
      open={open}
      onClose={onClose}
      fullWidth
      align="top"
    >

      <div className={classes.tabsContainer}>
        <Tabs
          options={tabOptions}
          value={tab}
          onChange={handleChangeTab}
        />
      </div>

      <div key={tab} className="fadeIn">
        {
          tab === 'simulate' &&
          <SimulateSection graphData={graphData} onChangeGraphData={onChangeGraphData} />
        }
        {
          tab === 'subroutines' &&
          <SubroutineSection graphData={graphData} onChangeGraphData={onChangeGraphData} />
        }
        {/*
          tab === 'resources' &&
          <CostsSection graphData={graphData} onChangeGraphData={onChangeGraphData} />
        */}
        {
          tab === 'export' &&
          <ExportSection graphData={graphData} saveModel={saveModel} />
        }
        {
          tab === 'import' &&
          <ImportSection onChangeGraphData={onChangeGraphData} onClose={onClose} />
        }
        {
          tab === 'advanced' &&
          <AdvancedSection graphData={graphData} onChangeGraphData={onChangeGraphData} />
        }
      </div>

    </Dialog>
  );
}
